module.exports = __webpack_public_path__ + "img/Medic.1ce9eff9.png";